import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '@services/user.service';

@Component({
    template: ''
})
export class LogoutComponent {
    private router = inject(Router);
    private userService = inject(UserService);

    constructor() {
        this.userService.logout().then(() => this.router.navigate(['/login']));
    }
}
